<template>
  <div :class="classList" class="ruejai-club-package-selector">
    <searchable-ruejai-club-package-list
      v-if="showSearchList"
      :query="query"
      :is-loading="isLoading"
      :value="selectablePackages"
      class="search-list"
      @queryChange="handleQueryChange"
      @select="handleSelectPackage"
    ></searchable-ruejai-club-package-list>
    <selected-ruejai-club-package-list
      :disabled="disabled"
      :value="value"
      class="selected-list"
      @remove="handleRemovePackage"
      @removeAll="handleRemoveAllPackage"
    ></selected-ruejai-club-package-list>
  </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import { debounce } from "@/lib/util";
import differenceWith from "ramda/src/differenceWith";
import SearchableRuejaiClubPackageList from "./SearchableRuejaiClubPackageList";
import SelectedRuejaiClubPackageList from "./SelectedRuejaiClubPackageList";

export default {
  components: {
    SelectedRuejaiClubPackageList,
    SearchableRuejaiClubPackageList,
  },
  props: {
    initialPackages: {
      type: Array,
      default: null
    },
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      query: "",
      allPackages: [],
      isLoading: false
    };
  },
  computed: {
    selectablePackages() {
      return differenceWith(this.comparePackage, this.allPackages, this.value);
    },
    showSearchList() {
      return !this.disabled;
    },
    classList() {
      return { disabled: this.disabled };
    }
  },
  watch: {
    query() {
      this.watchQuery();
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupPackages();
    },
    async setupPackages() {
      const params = this.query ? { name: this.query } : {};
      const packages = await this.fetchPackages(params);

      this.allPackages = packages.map(item => {
        const {
          id,
          name,
          detail,
          type,
          thumbnail_url: thumbnailUrl
        } = item;

        return {
          id,
          name,
          detail,
          type,
          thumbnailUrl
        };
      });
    },
    async fetchPackages(params = {}) {
      if (this.initialPackages) {
        return this.initialPackages;
      }

      this.isLoading = true;
      const response = await baanRueJaiClient.admin.ruejaiClub.packages.list(
        params
      );

      this.isLoading = false;
      return response.data.result.items;
    },
    handleSelectPackage(item) {
      this.updateInput([...this.value, item]);
    },
    handleRemovePackage(item) {
      this.updateInput(this.value.filter(({ id }) => item.id !== id));
    },
    async handleRemoveAllPackage() {
      try {
        await this.$confirm("คุณต้องการลบรายการ package ใช่หรือไม่", "ยืนยัน", {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
          type: "warning"
        });
      } catch {
        return;
      }

      this.updateInput([]);
    },
    updateInput(value) {
      this.$emit("input", value);
    },
    comparePackage(item, item2) {
      return item.id === item2.id;
    },
    handleQueryChange(value) {
      this.query = value;
    },
    watchQuery: debounce(function watchQuery() {
      this.setupPackages();
    }, 1.5)
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.ruejai-club-package-selector {
  display: grid;
  grid-template-columns: 1fr 1fr;

  > .search-list {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  > .selected-list {
    border-left-width: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.ruejai-club-package-selector.disabled {
  display: block;

  > .selected-list {
    border-left-width: 1px;
    border-radius: $border-radius;
  }
}
</style>
